import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteClassType(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteClassType = (kiloClassTypeId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`kilo-class-types/${kiloClassTypeId}/`);
  };

  return useMutation(deleteClassType, {
    onSuccess: () => {
      queryClient.removeQueries(['classType']);
      queryClient.invalidateQueries({ queryKey: ['classPayRateLookups'] });
      queryClient.invalidateQueries({ queryKey: ['packages'] });
      queryClient.invalidateQueries({ queryKey: ['attendanceRules'] });
      queryClient.invalidateQueries({ queryKey: ['creditDispensations'] });
    },
  });
}
